import { CommonModule } from "@angular/common";
import { Component, input, output } from "@angular/core";

import { ALPHABET } from "@lib/constants/alphabet";

@Component({
  selector: "app-alphabet-scroller",
  imports: [CommonModule],
  templateUrl: "./alphabet-scroller.component.html",
  styleUrl: "./alphabet-scroller.component.scss",
})
export class AlphabetScrollerComponent {
  readonly availableLetters = input.required<Set<string>>();
  readonly activeLetter = input<string | null>(null);

  readonly letterClick = output<string>();

  readonly alphabet = ALPHABET;

  isLetterAvailable(letter: string): boolean {
    return this.availableLetters().has(letter);
  }

  onLetterClick(letter: string): void {
    this.letterClick.emit(letter);
  }
}
